window.onload = async (event) => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	const source = urlParams.get('utm_source')

	if(source) {
		let global_variable_name = '';
		let global_variable_value = '';

		switch (source) {
			case 'Alen-Air':
				global_variable_name  = '_mobile_checkout_data';
				global_variable_value =	{origin: 'Alen-Air App'};
				break;

			default:
                global_variable_name = false;
				break;
		}

        if(global_variable_name != false) {
    		createCookie(global_variable_name,global_variable_value,10);
  
    		if(getCookieValue(global_variable_name) == false) {
    			window.location.reload();
    		}
        }


	}

};

/**
 * Sets a cookie with a given name, value, and expiration time in days.
 * @param {string} name - The name of the cookie.
 * @param {string|object} value - The value to store (serialized if it's an object).
 * @param {number} days - The number of days until the cookie expires.
 */
const createCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    const serializedValue = typeof value === "object" ? JSON.stringify(value) : value;
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(serializedValue)}; expires=${expires}; path=/`;
};


/**
 * Gets the value of a cookie by its name and attempts to parse it if it's JSON.
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {string|object|false} - The cookie value (parsed if it's JSON) or false if it doesn't exist.
 */
const getCookieValue = (cookieName) => {
    const cookies = Object.fromEntries(
        document.cookie
            .split("; ")
            .map(cookie => cookie.split("=").map(decodeURIComponent))
    );
    const value = cookies[cookieName] || false;

    if (value) {
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    }

    return false;
};

/**
 * Deletes a cookie by its name.
 * @param {string} name - The name of the cookie to delete.
 */
const deleteCookie = (name) => {
    document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const addPurchaseSourceAttr = (source) => {

	const updateBody = {
		attributes: {
			source: source
		}
	};

	let xhr = new XMLHttpRequest();
	xhr.open("POST", '/cart/update.js', true);
	xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

	xhr.onreadystatechange = function() {
		if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
			deleteCookie('_mobile_checkout_data');
		}
	};
	  xhr.send(JSON.stringify(updateBody));
}

